<template>
    <grid class="c-m g-m">
        <row class="c-m" :reverse="!1" end="xs" middle="xs">
            <column :xs="3">
                <b>{{$t('choose_label')}}</b>
            </column>
            <column :xs="7">
                <label class="dock-pull-select-label">
                    <select class="dock-pull-select" v-model="language">
                        <option value="ru">{{$t('language.type.ru')}}</option>
                        <option value="en">{{$t('language.type.en')}}</option>
                    </select>
                </label>
            </column>
            <column :xs="2"></column>
        </row>
    </grid>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'Language',
  computed: {
    ...mapGetters(['lang']),
    language: {
      set (n) {
        this.setLang(n).then(() => {
          this.$router.replace({query: {temp: Date.now()}})
          this.$router.replace({query: {temp: undefined}})
          this.$forceUpdate()
        })
      },
      get () {
        return this.lang
      }
    }
  },
  methods: {
    ...mapActions(['setLang'])
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/settings/Language.vue